import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Heading, Text } from "grommet";
import * as React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import CreateTournament from "./CreateTournament";
import TournamentProfile from "./TournamentProfile";
import { TournamentRow } from "./TournamentRow";
import { getTournaments, TournamentViewModel } from "./TournamentsStore";
import TournamentsList from "./TournamentsList";

export const newTournamentIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "trophy-star"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-15 right-15" />
    </span>
);

const TournamentsManagement = () => {
    const hasWritePermission = usePermission("sport:tournaments.write");

    return (
        <div>
            <Routes>
                <Route path={"create"} element={<>{hasWritePermission && <CreateTournament />}</>}></Route>
                <Route path={":id/*"} element={<TournamentProfile />}></Route>
                <Route path={""} element={<TournamentsList></TournamentsList>}></Route>
            </Routes>
        </div>
    );
};

export default TournamentsManagement;
